<template>
    <div class="uk-padding">
        <div class="uk-container">

            <h1 class="uk-text-left">
                <span class="half-a-border-on-top">Request Information</span>
            </h1>
            <p>Please complete the form below so we may have a dialogue on your programme of interest.</p>
            <div class="uk-card uk-card-default" >
                <div uk-grid >
                    <div class="uk-width-1-2@m uk-visible@m" style="border-radius: 5px; background: rgb(51, 51, 51)" >
                        <div class="worthless" style="min-height: 45%; background: gold; margin-top: 10%; margin-left: -38px;">
                            <div class="worthlessness"></div>
                        </div>

                        <div class="great" style="min-height: 45%; background: #033860; margin-left: -38px;">
                            <div class="greater" >

                            </div>
                        </div>

                    </div>
                    <div class="uk-width-1-2@m " id="formPad">
                        <form  @submit.prevent="validatePostForm('requestInfo')"  data-vv-scope="requestInfo" style="padding: 15px !important;">

                                <h5 class="uk-heading-bullet uk-text-bold uk-text-uppercase">Contact Information.</h5>
                                <div class="uk-margin uk-child-width-1-1@l" uk-grid>
                                    <div class="">
                                        <label for="firstName" class="uk-text-small uk-text-bold">First Name</label>
                                        <input id="firstName" class="uk-input" type="text" placeholder="First Name" v-validate="'required'" name="firstName" v-model="firstName" >
                                        <span class="errorMsg" style="">{{ errors.first('requestInfo.firstName') }}</span>
                                    </div>
                                    <div class="">
                                        <label for="middleName" class="uk-text-small uk-text-bold">Middle Name</label>
                                        <input id="middleName" class="uk-input" type="text" placeholder="Middle Name" v-validate="'required'" name="middleName" v-model="middleName">
                                        <span class="errorMsg" style="">{{ errors.first('requestInfo.middleName') }}</span>
                                    </div>
                                    <div class="">
                                        <label for="lastName" class="uk-text-small uk-text-bold">Last Name</label>
                                        <input id="lastName" class="uk-input" type="text" placeholder="Last Name" v-validate="'required'" name="lastName" v-model="lastName">
                                        <span class="errorMsg" style="">{{ errors.first('requestInfo.lastName') }}</span>
                                    </div>

                                </div>
                                <div class="uk-margin">
                                    <label for="tele" class="uk-text-small uk-text-bold">Telephone Number</label>
                                    <input id="tele" class="uk-input" type="text" placeholder="Telephone No." v-validate="'required'"
                                           name="telephone" v-model="telephone" v-mask="maskPhone" :placeholder="phoneHolder">
                                    <span class="errorMsg" style="">{{ errors.first('requestInfo.telephone') }}</span>
                                </div>
                                <div class="uk-margin">
                                    <label for="email" class="uk-text-small uk-text-bold">Email Address</label>
                                    <input id="email" class="uk-input" type="text" placeholder="Email Address" v-validate="'required'" name="email" v-model="email">
                                    <span class="errorMsg" style="">{{ errors.first('requestInfo.email') }}</span>
                                </div>
                                <div class="uk-margin uk-margin-remove-bottom uk-grid-small uk-child-width-auto uk-grid">
                                    <label for="">Gender:</label>
                                    <label><input class="uk-radio" type="radio" name="gender" v-model="gender" value="Male" v-validate="'required'"> Male</label>
                                    <label><input class="uk-radio" type="radio" name="gender" v-model="gender" value="Female"> Female</label>
                                </div>
                                <span class="errorMsg" style="">{{ errors.first('requestInfo.gender') }}</span>
                                <div class="uk-margin uk-margin-remove-top">
                                    <label for="location" class="uk-text-small uk-text-bold">How did we meet?</label>
                                    <select id="location" class="uk-select" v-validate="'required'" name="location" v-model="location">

                                        <option value="Career Talk/Fair at Your School">Career Talk/Fair at Your School</option>
                                        <option value="Presentation at Church/Community Group">Presentation at Church/Community Group</option>
                                        <option value="Virtual Open House">Virtual Open House</option>
                                        <option value="Guidance Counsellor/Teacher">Guidance Counsellor/Teacher</option>
                                        <option value="Church Representative">Church Representative</option>
                                        <option value="Mentor/Family Friend">Mentor/Family Friend</option>
                                        <option value="N/A">N/A</option>
                                    </select>

                                </div>

                          <h5 class="uk-heading-bullet uk-text-bold uk-text-uppercase">Religious information</h5>
                          <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                          <label for="" class="uk-text-bold">Are you an Adventist?</label><br>
                          <label><input class="uk-radio" type="radio" name="degreeType" value="Yes" id="yesRadio" @click="adventistChoice($event.target.id)" > Yes</label>
                          <label><input class="uk-radio" type="radio" name="degreeType" value="No"  id="noRadio"  @click="adventistChoice($event.target.id)"> No</label>
                            </div>
                          <div class="uk-margin " v-if="yesAdventist" >

                            <div class="uk-margin">
                              <label for="churchConference" class="uk-text-small uk-text-bold">Church Conference</label>
                              <input id="churchConference" class="uk-input" type="text" placeholder="Church Conference" v-validate="'required'" name="churchConference" v-model="churchConference">
                              <span class="errorMsg" style="">{{ errors.first('requestInfo.churchConference') }}</span>
                            </div>
                            <div class="uk-margin">
                              <label for="churchDistrict" class="uk-text-small uk-text-bold">Name of Church</label>
                              <input id="churchDistrict" class="uk-input" type="text" placeholder="Name of Church" v-validate="'required'" name="churchDistrict" v-model="churchDistrict">
                              <span class="errorMsg" style="">{{ errors.first('requestInfo.churchDistrict') }}</span>
                            </div>
                          </div>

                                <h5 class="uk-heading-bullet uk-text-bold uk-text-uppercase">Academic information</h5>
                                <h6 class="uk-text-uppercase uk-text-bold" style="color: teal; margin-top: -15px; margin-left: 13px;">Current</h6>
                                <div class="uk-margin">
                                    <label for="location" class="uk-text-small uk-text-bold">Tell us your current/past school</label>
                                    <input class="uk-input" type="text" placeholder="Current/ Last School" name="lastSchool" v-model="lastSchool" v-validate="'required'">
                                    <span class="errorMsg" style="">{{ errors.first('requestInfo.lastSchool') }}</span>
                                </div>
                                <div class="uk-margin">
                                    <label for="grade" class="uk-text-small uk-text-bold">Grade/Form/Year</label>
                                    <select id="grade" class="uk-select" name="grade" v-model="grade" v-validate="'required'">

                                        <option value="Grade 7">Grade 7</option>
                                        <option value="Grade 8">Grade 8</option>
                                        <option value="Grade 9">Grade 9</option>
                                        <option value="Grade 10">Grade 10</option>
                                        <option value="Grade 11">Grade 11</option>
                                        <option value="Grade 12">Grade 12</option>
                                        <option value="Grade 13">Grade 13</option>
                                        <option value="Freshman">Freshman</option>
                                        <option value="Sophomore">Sophomore</option>
                                        <option value="Junior">Junior</option>
                                        <option value="Senior">Senior</option>
                                        <option value="Vocational Training">Vocational Training</option>
                                        <option value="Graduated">Graduated</option>
                                        <option value="None">None</option>
                                    </select>
                                    <span class="errorMsg" style="">{{ errors.first('requestInfo.grade') }}</span>
                                </div>

                                <h6 class="uk-text-uppercase uk-text-bold" style="color: teal; margin-top: 0; margin-left: 13px;">Future</h6>
                                <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">

                                    <label for="" class="uk-text-bold">Programme Level:</label><br>
                                    <label><input class="uk-radio" type="radio" name="degreeType" value="Certificate" v-model="programChoice" id="certificateRadio" @click="showType($event.target.id)"  v-validate="'required'"> Certificate</label>
                                    <label><input class="uk-radio" type="radio" name="degreeType" value="Undergraduate" v-model="programChoice" id="undergradRadio"  @click="showType($event.target.id)"> Undergraduate</label>
                                    <label><input class="uk-radio" type="radio" name="degreeType" value="Graduate" v-model="programChoice"  id="gradRadio"  @click="showType($event.target.id)"> Graduate</label>
                                </div>
                                <div class="uk-margin " v-if="certCheck" >
                                    <label for="certificate" class="uk-text-small uk-text-bold">Certificate</label>
                                    <select id="certificate" class="uk-select" name="certificate" v-model="degreeChoice" >
                                        <option disabled selected="selected">-- Choose a certificate of your interest --</option>
                                        <option value="Application Development">Application Development</option>
                                        <option value="Education">Education</option>
                                        <option value="Tropical Agriculture">Tropical Agriculture</option>
                                        <option value="Information Security">Information Security</option>
                                        <option value="Information Technology">Information Technology</option>
                                        <option value="Network Administration"> Network Administration</option>
                                        <option value="Technology Development"> Technology Development</option>
                                        <option value="Conflict Resolution & Management">Conflict Resolution & Management</option>
                                        <option value="Crime & Security Management">Crime & Security Management</option>
                                        <option value="Crisis, Trauma & Grief Counselling">Crisis, Trauma & Grief Counselling</option>
                                        <option value="Techniques of Photography">Techniques of Photography</option>
                                        <option value="Public Speaking">Public Speaking</option>
                                        <option value="Performance and Pedagogy">Performance and Pedagogy</option>
                                        <option value="Business Communication & Writing">Business Communication & Writing</option>
                                        <option value="Digital Marketing">Digital Marketing</option>
                                        <option value="Introductory Principles of Accounting & Finance">Introductory Principles of Accounting & Finance</option>
                                        <option value="Investment and Portfolio Management">Investment and Portfolio Management</option>
                                        <option value="Family Life Education">Family Life Education</option>
                                        <option value="Logistics & Supply Management">Logistics & Supply Management</option>
                                        <option value="Project Management">Project Management</option>
                                        <option value="Small Business Management">Small Business Management</option>
                                        <option value="SDA Teacher Certification">SDA Teacher Certification</option>
                                        <option value="Sales & Marketing">Sales & Marketing</option>
                                        <option value="Social Media Strategist">Social Media Strategist</option>
                                        <option value="Supervisory Management">Supervisory Management</option>
                                        <option value="Tax and Taxation">Tax and Taxation</option>
                                        <option value="Telephone Hotline Counselling">Telephone Hotline Counselling</option>
                                        <option value="Customer Relations">Customer Relations</option>
                                        <option value="Events Planning">Events Planning</option>
                                        <option value="Introduction to Hotel Operations Management">Introduction to Hotel Operations Management</option>
                                        <option value="Introduction to Occupational Health & Safety">Introduction to Occupational Health & Safety</option>
                                        <option value="CompTia - A+">CompTia - A+</option>
                                        <option value="CompTia - Linux">CompTia - Linux</option>
                                        <option value="CompTia - Network+">CompTia - Network+</option>
                                        <option value="CompTia - Project+">CompTia - Project+</option>
                                        <option value="CompTia - Security+">CompTia - Security+</option>
                                        <option value="Microsoft - 70-410: Installing and Configuring Windows Server 2012">Microsoft - 70-410: Installing and Configuring Windows Server 2012</option>
                                        <option value="Microsoft - 70-411: Administering Windows Server 2012">Microsoft - 70-411: Administering Windows Server 2012</option>
                                        <option value="Microsoft - 70-412: Configuring Advanced Windows Server 2012 Services">Microsoft - 70-412: Configuring Advanced Windows Server 2012 Services</option>
                                        <option value="Microsoft - 70-740: Installation, Storage, and Compute with Windows Server 2016">Microsoft - 70-740: Installation, Storage, and Compute with Windows Server 2016</option>
                                        <option value="TestOut - Desktop Pro">TestOut - Desktop Pro</option>
                                        <option value="TestOut - PC Pro">TestOut - PC Pro</option>
                                        <option value="TestOut - Network Pro">TestOut - Network Pro</option>
                                        <option value="TestOut - Security Pro">TestOut - Security Pro</option>
                                        <option value="TestOut - Linux Pro">TestOut - Linux Pro</option>
                                        <option value="TestOut - Routing Pro">TestOut - Routing Pro</option>
                                        <option value="TestOut - Switching Pro">TestOut - Switching Pro</option>
                                        <option value="CIW - Internet Business Associate">CIW - Internet Business Associate</option>
                                        <option value="CIW - Site Development Associate">CIW - Site Development Associate</option>
                                        <option value="CIW - Network Technology Associate">CIW - Network Technology Associate</option>
                                        <option value="CIW - Web Security Associate">CIW - Web Security Associate</option>
                                        <option value="CIW - Advanced HTML5 and CSS3 Specialist">CIW - Advanced HTML5 and CSS3 Specialist</option>
                                        <option value="CIW - User Interface Designer">CIW - User Interface Designer</option>
                                        <option value="CIW - Database Design Specialist">CIW - Database Design Specialist</option>
                                    </select>
                                </div>
                                <div class="uk-margin"  v-if="gCheck" >
                                    <label for="gradDegree" class="uk-text-small uk-text-bold">Choose an Graduate Programmes</label>
                                    <select id="gradDegree" class="uk-select" v-model="degreeChoice" name="undergradDegree">
                                        <option disabled selected="selected">-- Choose a Undergraduate Program --</option>
                                        <option value="Biology">Biology</option>
                                        <option value="Business Administration">Business Administration</option>
                                        <option value="Counselling Psychology">Counselling Psychology</option>
                                        <option value="Education">Education</option>
                                        <option value="Educational Psychology">Educational Psychology</option>
                                        <option value="Information Systems">Information Systems</option>
                                        <option value="Public Health">Public Health</option>
                                        <option value="Science Education">Science Education</option>

                                    </select>
                                </div>
                                <div class="uk-margin"  v-if="uCheck" >
                                    <label for="undergradDegree" class="uk-text-small uk-text-bold">Choose an Undergraduate Programmes</label>
                                    <select id="undergradDegree" class="uk-select"  v-model="degreeChoice" name="gradDegree">
                                        <option disabled selected="selected">-- Choose a Graduate Program --</option>
                                        <option value="Agriculture">Agriculture</option>
                                        <option value="Agronomy">Agronomy</option>
                                        <option value="Applied Environmental Geography">Applied Environmental Geography</option>
                                        <option value="Biochemistry">Biochemistry</option>
                                        <option value="Biological Science">Biological Science</option>
                                        <option value="Biology">Biology</option>
                                        <option value="Business Administration">Business Administration</option>
                                        <option value="Chemistry">Chemistry</option>
                                        <option value="Communication Studies">Communication Studies</option>
                                        <option value="Computer Information Systems">Computer Information Systems</option>
                                        <option value="Computer Science">Computer Science</option>
                                        <option value="Computer Systems Engineering">Computer Systems Engineering</option>
                                        <option value="Counselling">Counselling</option>
                                        <option value="Criminal Justice">Criminal Justice</option>
                                        <option value="Cyber Security">Cyber Security</option>
                                        <option value="Dental Hygiene">Dental Hygiene</option>
                                        <option value="Dietetics">Dietetics</option>
                                        <option value="Early Childhood Education">Early Childhood Education</option>
                                        <option value="Electrical and Electronic Engineering">Electrical and Electronic Engineering</option>
                                        <option value="English">English</option>
                                        <option value="Environmental Science">Environmental Science</option>
                                        <option value="Family Life Education">Family Life Education</option>
                                        <option value="Family Studies">Family Studies</option>
                                        <option value="Guidance Counselling">Guidance Counselling</option>
                                        <option value="History">History</option>
                                        <option value="Hospitality and Tourism Management">Hospitality and Tourism Management</option>
                                        <option value="Information Technology">Information Technology</option>
                                        <option value="Management Studies">Management Studies</option>
                                        <option value="Mathematics">Mathematics</option>
                                        <option value="Medical Technology">Medical Technology</option>
                                        <option value="Music">Music</option>
                                        <option value="Music Education">Music Education</option>
                                        <option value="Nursing">Nursing</option>
                                        <option value="Performance and Pedagogy">Performance and Pedagogy</option>
                                        <option value="Primary Teacher Education">Primary Teacher Education</option>
                                        <option value="Psychology">Psychology</option>
                                        <option value="Religion and Theology">Religion and Theology</option>
                                        <option value="Secondary Teacher Education">Secondary Teacher Education</option>
                                        <option value="Social Work">Social Work</option>
                                        <option value="Spanish Education">Spanish Education</option>
                                        <option value="Spanish Studies">Spanish Studies</option>
                                        <option value="Special Education">Special Education</option>
                                        <option value="Visual Arts">Visual Arts</option>
                                    </select>
                                </div>

                                <hr style="height: 1px; background: gold">
                                <div class="uk-margin">
                                    <label for="additionInfo" class="uk-text-small uk-text-bold">Any additional information you wish to know</label>
                                    <textarea id="additionInfo" class="uk-textarea" rows="5" v-model="additionInfo" name="additionInfo"
                                              placeholder="Addition Information you wish to add"
                                              style="resize: none; border-radius: 5px;"></textarea>
                                </div>
                                <div>
                                  <p class="uk-text-muted uk-text-small"><span class="uk-margin-small-right uk-text-success uk-text-bold" uk-icon="check"></span> By submitting this form your are agreeing to be contacted via Whatsapp call or message</p>
                                </div>
                                <div>
                                    <button class="uk-button uk-button-secondary" type="submit">Send</button>

                                </div>


                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Validator } from 'vee-validate';
    import moment from 'moment'
    import UIkit from 'uikit'
    let currentDate = new Date().toJSON().slice(0,10).replace(/-/g,'/');
    const dict = {
        custom: {
            firstName: { required: 'Please enter your first name' },
            middleName: { required: 'Please enter your middle name' },
            lastName: { required: 'Please enter your last name' },
            telephone: { required: 'Please enter your telephone no.' },
            email: { required: 'Please enter an email address' },
             churchDistrict: {required: 'Please enter your church name'},
          churchConference: {required: 'Please enter your church conference'},
          gender: { required: 'Please choose your gender' },
            location: { required: 'Please tell us your location' },
            lastSchool: { required: 'Please tell us your last/current school' },
            grade: { required: 'Please tell us what grade you are in' },
            degreeType: { required: 'Please tell us the category of your academic interest' },

            name: {
                required: () => 'Your name is empty'
            }
        }
    };

    Validator.localize('en', dict);
    export default {
        name: "RequestInformation",
        data(){
          return {
              firstName: '',
              middleName: '',
              lastName: '',
              telephone: '',
            cDate: '',
              email: '',
              gender: '',
              location: '',
              lastSchool: '',
              grade: '',
            churchDistrict:'',
            yesAdventist: false,
            noAdventist: false,
            churchConference:'',
              degreeType: '',
              additionInfo: '',
              undergradDegree: '',
              gradDegree: '',
              certificate: '',
              phoneHolder: '(xxx) xxx xxxx',
              maskPhone: '(###)###-####',
              certCheck: false,
              uCheck: false,
              gCheck: false,
              degreeChoice: '',
              programChoice: '',

          }
        },
        methods: {
            validatePostForm(scope) {

                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        // eslint-disable-next-line
                      /*let data = new FormData();

                      data.append('firstName', this.firstName );
                      data.append('middleName', this.middleName );
                      data.append('lastName', this.lastName );
                      data.append('telephone', this.telephone );
                      data.append('email', this.email);
                      data.append('gender', this.gender);
                      data.append('location', this.location);
                      data.append('lastSchool', this.lastSchool);
                      data.append('grade', this.grade);
                      data.append('degreeType', this.degreeType);
                      data.append('additionInfo', this.additionInfo);
                      data.append('undergradDegree', this.undergradDegree);
                      data.append('gradDegree', this.gradDegree);
                      data.append('certificate', this.certificate);
                      this.certCheck ? this.degreeChoice = 'Certificate' : this.uCheck ? this.degreeChoice = 'Undergraduate' : this.degreeChoice = 'Graduate'
                      this.certCheck ? this.programChoice = this.certificate : this.uCheck ? this.programChoice = this.undergradDegree : this.programChoice = this.gradDegree
*/
                      let self = this
                      grecaptcha.ready(function() {
                        grecaptcha.execute('6LdXZlkeAAAAADundXZKRCbc2z0WfuFIfw-V9-az', { action: 'submit'}).then(function(token) {
                          // Add your logic to submit to your backend server here.
                            console.log(currentDate);
                          self.$store.dispatch('sendRequest',//data
                              {
                                'entryDate': currentDate,
                                'firstName': self.firstName,
                                'middleName': self.middleName,
                                'lastName': self.lastName,
                                'telephone': self.telephone,
                                'email': self.email,
                                'gender': self.gender,
                                'location': self.location,
                                'lastSchool': self.lastSchool,
                                'grade': self.grade,
                                'degreeType': self.degreeType,
                                'additionInfo': self.additionInfo,
                                'programChoice': self.programChoice,
                                'degreeChoice': self.degreeChoice,
                                'churchConference': self.churchConference,
                                'churchDistrict': self.churchDistrict,
                                //'certificate': this.certificate
                              })
                              .then(response => {
                                console.log("Date: " + currentDate);
                                console.log(response)
                                UIkit.notification({
                                  message: 'Your request has been submitted. We will contact you in no later than 3 working days',
                                  status: 'success',
                                  pos: 'top-right',
                                  timeout: 7000
                                });
                                //UIkit.notification("Your request has been submitted. We will contact you in no later than 3 working days", {status:'success'})
                                //UIkit.notification('Your request has been submitted. We will contact you in no later than 3 working days', 'success');
                                self.$validator.reset(scope);
                                self.firstName = ''
                                self.lastName = ''
                                self.cDate = currentDate
                                self.telephone = null
                                self.email = null
                                self.gender = null
                                self.location = null
                                self.lastSchool = null
                                self.grade = null
                                self.degreeType = null
                                self.additionInfo = null
                                self.undergradDegree = null
                                self.gradDegree = null
                                self.certificate = null
                                self.churchDistrict = null
                                self.churchConference = null
                                location.reload();
                              })
                        });
                      });

                    }else{
                        console.log(this.$validator.errors)
                    }
                }).catch(err =>{
                    console.log(err)
                });
            },
            showType(event){
                console.log(event)
                //console.log(this.degreeType)
                switch(event) {
                    case 'certificateRadio':
                        // code block

                        this.uCheck = false
                        this.gCheck = false
                        this.certCheck = true
                        break;
                    case 'undergradRadio':
                        // code block
                        this.certCheck = false
                        this.gCheck = false
                        this.uCheck = true
                        break;
                     case 'gradRadio':
                        // code block
                         this.gCheck = true
                         this.certCheck = false
                         this.uCheck = false
                        break;

                    default:
                    // code block
                }
            },
          adventistChoice(event){
            console.log(event)
            //console.log(this.degreeType)
            switch(event) {
              case 'yesRadio':
                // code block
                this.noAdventist = false
                this.yesAdventist = true
                break;
              case 'noRadio':
                // code block
                this.noAdventist = true
                this.yesAdventist = false
                break;
              default:
                // code block
            }
          }
        }
    }
</script>

<style scoped>
    .uk-text-small{
        color: #555;
    }
    .errorMsg{
        font-size: small;
        color: #800;
        padding-left: 5px;
        font-weight: bold;
    }
    h5{
        color: #033860;
        text-decoration: overline;
        text-decoration-color: gold;
    }

    input, select{
        border-radius: 5px;
    }
    .half-a-border-on-top {
        border-top: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: white;
        position: absolute;
        right:0;
        top:-10px;
    }
    .great{
        transform: skewY(-10deg);
    }
    .greater{
        transform: skewY(10deg);
    }

    .great:after{
        content:"";
        position:absolute;
        background-color: #F5F5F5;
        transform: rotate(10deg);
        transform-origin: 0% 0%;

    }
    .worthless{
        transform: skewY(10deg);
    }
    .worthlessness{
        transform: skewY(-10deg);
    }

    .worthless:after{
        content:"";
        position:absolute;
        background-color: #F5F5F5;
        transform: rotate(-10deg);
        transform-origin: 0% 0%;

    }
    @media screen and (min-width: 600px){
        form{
            padding: 15px;
            padding-left: 30px;

        }
        .uk-card-default{
            padding: 45px;
        }
    }
    @media screen and (min-width: 960px){
        form{
            padding: 15px;
        }
        .uk-card-default{
            padding: 45px;
        }
    }
</style>
